import { render, staticRenderFns } from "./TodaysQC.vue?vue&type=template&id=4c6a225d&scoped=true&"
import script from "./TodaysQC.vue?vue&type=script&lang=js&"
export * from "./TodaysQC.vue?vue&type=script&lang=js&"
import style0 from "./TodaysQC.vue?vue&type=style&index=0&id=4c6a225d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6a225d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
